// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"middle__wrap--3jkrN"};